/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GeneralInformationResponseDto,
  UpdateGeneralInformationRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GeneralInformationResponseDtoFromJSON,
    GeneralInformationResponseDtoToJSON,
    UpdateGeneralInformationRequestDtoFromJSON,
    UpdateGeneralInformationRequestDtoToJSON,
} from '../models/index';

export interface GetGeneralInformationByPatientIdRequest {
    patientId: string;
}

export interface UpdateGeneralInformationRequest {
    updateGeneralInformationRequestDto: UpdateGeneralInformationRequestDto;
}

/**
 * 
 */
export class PatientsGeneralInformationApi extends runtime.BaseAPI {

    /**
     * Get patient\'s general information
     */
    async getGeneralInformationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralInformationResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/general-information`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralInformationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s general information
     */
    async getGeneralInformation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralInformationResponseDto> {
        const response = await this.getGeneralInformationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s general information by patient ID
     */
    async getGeneralInformationByPatientIdRaw(requestParameters: GetGeneralInformationByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralInformationResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getGeneralInformationByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/general-information/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralInformationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s general information by patient ID
     */
    async getGeneralInformationByPatientId(requestParameters: GetGeneralInformationByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralInformationResponseDto> {
        const response = await this.getGeneralInformationByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update patient\'s general information
     */
    async updateGeneralInformationRaw(requestParameters: UpdateGeneralInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneralInformationResponseDto>> {
        if (requestParameters['updateGeneralInformationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateGeneralInformationRequestDto',
                'Required parameter "updateGeneralInformationRequestDto" was null or undefined when calling updateGeneralInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/general-information`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGeneralInformationRequestDtoToJSON(requestParameters['updateGeneralInformationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralInformationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update patient\'s general information
     */
    async updateGeneralInformation(requestParameters: UpdateGeneralInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneralInformationResponseDto> {
        const response = await this.updateGeneralInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
